import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import MainNavigator from "./navigation/MainNavigator";

const { REACT_APP_ALLOW_INDEXING } = process.env;

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        {REACT_APP_ALLOW_INDEXING === 'false' && (
          <meta name="robots" content="noindex" />
        )}
      </Helmet>
      <MainNavigator />
    </HelmetProvider>
  );
}

export default App;
